namespace TabAurous.Retail {
    export interface POSOrderAddressRow {
        AddressId?: number;
        Type?: number;
        TransId?: number;
        Address1?: string;
        POSCustomerId?: number;
        City?: number;
        State?: number;
        Country?: number;
        Pincode?: string;
        CityName?: string;
        StateName?: string;
        CountryName?: string;
    }

    export namespace POSOrderAddressRow {
        export const idProperty = 'AddressId';
        export const nameProperty = 'Address1';
        export const localTextPrefix = 'Retail.POSOrderAddress';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            AddressId = "AddressId",
            Type = "Type",
            TransId = "TransId",
            Address1 = "Address1",
            POSCustomerId = "POSCustomerId",
            City = "City",
            State = "State",
            Country = "Country",
            Pincode = "Pincode",
            CityName = "CityName",
            StateName = "StateName",
            CountryName = "CountryName"
        }
    }
}
